// Console error ring buffer.
//
// Captures the last N window.onerror + unhandledrejection entries so
// the bug-report drawer can attach them to a submission without the
// user having to copy/paste from the dev tools.
//
// Installed once from Normal.js on first mount; subsequent mounts are
// no-ops (the listener attachment is guarded by a module-level flag).

const MAX_ERRORS = 10;
const ringBuffer = [];
let installed = false;

function push(entry) {
  ringBuffer.push({
    message: String(entry.message || "").slice(0, 2000),
    source: String(entry.source || "").slice(0, 500),
    lineno: typeof entry.lineno === "number" ? entry.lineno : null,
    ts: new Date().toISOString(),
  });
  while (ringBuffer.length > MAX_ERRORS) ringBuffer.shift();
}

export function installConsoleErrorBuffer() {
  if (installed || typeof window === "undefined") return;
  installed = true;
  window.addEventListener("error", (e) => {
    push({
      message: e.message || (e.error && e.error.message) || "Unknown error",
      source: e.filename || "",
      lineno: e.lineno || null,
    });
  });
  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    push({
      message: (reason && (reason.message || reason.toString && reason.toString())) || "Unhandled promise rejection",
      source: "(unhandled rejection)",
      lineno: null,
    });
  });
}

export function getRecentConsoleErrors() {
  return ringBuffer.slice();
}

export function clearConsoleErrorBuffer() {
  ringBuffer.length = 0;
}
